/* ============================================================================
 * Careers 2026 — page-specific JS.
 *   - Testimonial slider (prev/next, advances the whole left+right slide)
 *   - Job listing: fetches jobs from /ajax/getjobs/ then filters / sorts /
 *     paginates client-side (state / position / sort + clear + load more).
 *
 * Jobs are fetched client-side (not server-rendered) because the block lives
 * inside a cached headless REST render where the Job model can 503/hang.
 *
 * Compiled to /assets/js/pages/careers-2026.js via gulp's perPageScripts task.
 * Self-contained, no jQuery, plain DOM.
 * ============================================================================ */
(function () {
    'use strict';

    // ─── 1. Testimonial slider ─────────────────────────────────────────────
    document.querySelectorAll('[data-careers-testimonial]').forEach(function (carousel) {
        var slides = carousel.querySelectorAll('.careers-testimonial-slider__slide');
        if (slides.length < 2) return;
        var idx = 0;
        var show = function (i) {
            slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
            idx = i;
        };
        carousel.addEventListener('click', function (e) {
            var prev = e.target.closest('[data-careers-testimonial-prev]');
            var next = e.target.closest('[data-careers-testimonial-next]');
            if (prev) { show((idx - 1 + slides.length) % slides.length); }
            else if (next) { show((idx + 1) % slides.length); }
        });
    });

    // ─── 1b. CTA anchor — scroll in-page "#careers-jobs" links to the section
    //     heading, offset below the fixed header so it isn't hidden under it ──
    document.querySelectorAll('a[href="#careers-jobs"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var section = document.getElementById('careers-jobs');
            if (!section) return;
            var target = section.querySelector('.careers-job-listing__title') || section;
            var header = document.querySelector('header.fixed-top') || document.querySelector('.fixed-top');
            var offset = (header ? header.getBoundingClientRect().height : 0) + 24;
            var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
            e.preventDefault();
            window.scrollTo({ top: y, behavior: 'smooth' });
            if (window.history && history.replaceState) { history.replaceState(null, '', '#careers-jobs'); }
        });
    });

    // ─── 2. Job listing — fetch + filters + load more ──────────────────────
    document.querySelectorAll('[data-block="careers-job-listing"]').forEach(function (block) {
        var listEl   = block.querySelector('.careers-job-listing__list');
        var moreBtn  = block.querySelector('[data-careers-job-load-more]');
        var clearBtn = block.querySelector('[data-filter-clear]');
        var pills    = block.querySelectorAll('.careers-job-listing__filter-pill');
        if (!listEl) return;

        var url       = block.getAttribute('data-careers-jobs-url') || '/ajax/getjobs/';
        var initial   = parseInt(block.getAttribute('data-initial-limit'), 10) || 5;
        var emptyMsg  = block.getAttribute('data-empty-state') || 'No roles match those filters right now. Check back soon.';
        var step      = initial;

        var jobs  = [];
        var state = { state: null, position: null, sort: 'newest', visible: initial };

        var labelByType = { state: 'All state', position: 'Job Position', sort: 'Sort by' };

        function safe(value) {
            return String(value == null ? '' : value).replace(/[&<>"']/g, function (m) {
                return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
            });
        }

        function row(j) {
            var posRaw   = j.JobFunction || j.Department || j.Category;
            var category = Array.isArray(posRaw) ? posRaw.join(' / ') : (posRaw || '');
            var title    = j.Title || '';
            var u        = j.JobDetailsUrl || j.ApplyUrl || '#';
            if (Array.isArray(u)) u = u[0] || '#';
            var city     = j.City;
            var stateLbl = j.State;
            if (Array.isArray(city))     city     = city.filter(Boolean).join(', ');
            if (Array.isArray(stateLbl)) stateLbl = stateLbl.filter(Boolean).join(', ');
            var location = [city, stateLbl].filter(Boolean).join(', ');
            var emp      = j.WorkType || j.EmploymentType || '';
            if (Array.isArray(emp)) emp = emp.join(' / ');

            return ''
                + '<li class="careers-job-listing__row d-flex flex-wrap gap-3 align-items-center py-4">'
                +   '<div class="careers-job-listing__row-main flex-grow-1">'
                +     (category ? '<p class="careers-job-listing__row-category text-uppercase fw-bold fs-small mb-1">' + safe(category) + '</p>' : '')
                +     '<h3 class="careers-job-listing__row-title fs-4 fw-normal mb-0"><a href="' + safe(u) + '" class="text-decoration-none" target="_blank" rel="noopener noreferrer">' + safe(title) + '</a></h3>'
                +   '</div>'
                +   '<div class="careers-job-listing__row-tags d-flex flex-wrap gap-2">'
                +     (location ? '<span class="careers-job-listing__pill">' + safe(location) + '</span>' : '')
                +     (emp      ? '<span class="careers-job-listing__pill">' + safe(emp) + '</span>' : '')
                +   '</div>'
                + '</li>';
        }

        function jobUrl(j) {
            var u = j.JobDetailsUrl || j.ApplyUrl || '';
            return Array.isArray(u) ? (u[0] || '') : (u || '');
        }

        // The upstream Dayforce feed cross-posts a single role to several
        // recruitment portals (CANDIDATEPORTAL / SLC / HOPSTEPASC …), so the same
        // title arrives multiple times with different URLs. Collapse to one row
        // per title, preferring the generic candidate-portal link, then the most
        // recently posted entry.
        function dedupe(list) {
            var out = [], index = {};
            list.forEach(function (j) {
                if (!j) return;
                var key = String(j.Title || '').trim().toLowerCase().replace(/\s+/g, ' ');
                if (!key) { out.push(j); return; }
                if (!(key in index)) { index[key] = out.length; out.push(j); return; }
                var kept = out[index[key]];
                var keptGeneric = jobUrl(kept).indexOf('CANDIDATEPORTAL') !== -1;
                var thisGeneric = jobUrl(j).indexOf('CANDIDATEPORTAL') !== -1;
                var replace = (thisGeneric && !keptGeneric)
                    || (thisGeneric === keptGeneric
                        && new Date(j.DatePosted || 0) > new Date(kept.DatePosted || 0));
                if (replace) out[index[key]] = j;
            });
            return out;
        }

        function filter() {
            var out = jobs.filter(function (j) {
                if (!j) return false;
                if (state.state) {
                    var s = Array.isArray(j.State) ? j.State.map(String) : [String(j.State || '')];
                    if (s.map(function (x) { return x.toLowerCase(); }).indexOf(state.state.toLowerCase()) === -1) return false;
                }
                if (state.position) {
                    var posVal = j.JobFunction || j.Department || j.Category;
                    var c = Array.isArray(posVal) ? posVal.map(String) : [String(posVal || '')];
                    if (c.map(function (x) { return x.toLowerCase(); }).indexOf(state.position.toLowerCase()) === -1) return false;
                }
                return true;
            });
            out.sort(function (a, b) {
                if (state.sort === 'a-z') return String(a.Title || '').localeCompare(String(b.Title || ''));
                if (state.sort === 'oldest') return new Date(a.DatePosted || 0) - new Date(b.DatePosted || 0);
                return new Date(b.DatePosted || 0) - new Date(a.DatePosted || 0);
            });
            return out;
        }

        function render() {
            var filtered = filter();
            var visible = filtered.slice(0, state.visible);
            if (visible.length === 0) {
                listEl.innerHTML = '<li class="careers-job-listing__empty py-4 text-center fs-6">' + safe(emptyMsg) + '</li>';
            } else {
                listEl.innerHTML = visible.map(row).join('');
            }
            pills.forEach(function (pill) {
                var type = pill.getAttribute('data-filter-type');
                var label = pill.querySelector('.careers-job-listing__filter-label');
                var val = (type === 'sort') ? state.sort : state[type];
                if (val && val !== 'newest') {
                    if (label) label.textContent = (typeof val === 'string' ? val.replace('-', ' – ') : val).toUpperCase();
                    pill.classList.add('has-value');
                } else {
                    if (label) label.textContent = labelByType[type] || 'Filter';
                    pill.classList.remove('has-value');
                }
            });
            if (moreBtn) {
                if (filtered.length > state.visible) moreBtn.removeAttribute('hidden');
                else moreBtn.setAttribute('hidden', '');
            }
        }

        function buildMenus() {
            var stateSet = {}, positionSet = {};
            jobs.forEach(function (j) {
                if (j && j.State) (Array.isArray(j.State) ? j.State : [j.State]).forEach(function (x) { if (x) stateSet[x] = true; });
                var posField = j && (j.JobFunction || j.Department || j.Category);
                if (posField) (Array.isArray(posField) ? posField : [posField]).forEach(function (x) { if (x) positionSet[x] = true; });
            });
            var optionsByType = {
                state: Object.keys(stateSet).sort(),
                position: Object.keys(positionSet).sort(),
                sort: ['Newest', 'Oldest', 'A–Z'],
            };
            pills.forEach(function (pill) {
                var type = pill.getAttribute('data-filter-type');
                if (!type || pill.querySelector('.careers-job-listing__filter-menu')) return;
                var menu = document.createElement('div');
                menu.className = 'careers-job-listing__filter-menu';
                menu.setAttribute('role', 'listbox');
                (optionsByType[type] || []).forEach(function (opt) {
                    var btn = document.createElement('button');
                    btn.type = 'button';
                    btn.className = 'careers-job-listing__filter-option';
                    btn.setAttribute('data-value', opt);
                    btn.textContent = opt;
                    btn.addEventListener('click', function (e) {
                        e.stopPropagation();
                        var current = (type === 'sort') ? state.sort : state[type];
                        var lower = (type === 'sort') ? opt.toLowerCase().replace('–', '-') : opt;
                        var nextVal = (current === lower && type !== 'sort') ? null : lower;
                        if (type === 'sort') state.sort = nextVal || 'newest';
                        else state[type] = nextVal;
                        state.visible = initial;
                        pill.classList.remove('is-open');
                        render();
                    });
                    menu.appendChild(btn);
                });
                pill.appendChild(menu);
                pill.addEventListener('click', function (e) {
                    if (e.target.closest('.careers-job-listing__filter-menu')) return;
                    pills.forEach(function (p) { if (p !== pill) p.classList.remove('is-open'); });
                    pill.classList.toggle('is-open');
                });
            });
        }

        document.addEventListener('click', function (e) {
            if (!block.contains(e.target)) pills.forEach(function (p) { p.classList.remove('is-open'); });
        });
        if (clearBtn) clearBtn.addEventListener('click', function () {
            state.state = null; state.position = null; state.sort = 'newest'; state.visible = initial; render();
        });
        if (moreBtn) moreBtn.addEventListener('click', function () { state.visible += step; render(); });

        // Fetch all roles once, then drive filtering/sorting/pagination client-side.
        // The jobs feed is fetched live upstream (not cached server-side), so a
        // transient hiccup can yield an error/empty response — retry once before
        // falling back to the empty state.
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        var fetchUrl = url + sep + 'per_page=1000';

        function loadJobs(attempt) {
            fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(function (r) {
                    if (!r.ok) throw new Error('HTTP ' + r.status);
                    return r.json();
                })
                .then(function (data) {
                    var body = (data && Array.isArray(data.body)) ? data.body : [];
                    if (body.length === 0 && attempt < 1) {
                        setTimeout(function () { loadJobs(attempt + 1); }, 1500);
                        return;
                    }
                    jobs = dedupe(body);
                    buildMenus();
                    render();
                })
                .catch(function () {
                    if (attempt < 1) {
                        setTimeout(function () { loadJobs(attempt + 1); }, 1500);
                        return;
                    }
                    listEl.innerHTML = '<li class="careers-job-listing__empty py-4 text-center fs-6">' + safe(emptyMsg) + '</li>';
                    if (moreBtn) moreBtn.setAttribute('hidden', '');
                });
        }

        loadJobs(0);
    });
})();
